module.exports = __webpack_public_path__ + "img/1468987695.61efe071.jpg";